export enum TooltipOrigins {
  CARD = 'card',
  ICON = 'icon',
  LIST = 'list',
  RESUME_SIMULATION = 'resumeSimulation',
  TIMELINE = 'timeline'
}
